module.exports = __webpack_public_path__ + "img/logo_hk.99b97da9.png";